module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/247-somaliland-83c09c2ee537343a29df72eae20eda0e.svg";